export const Menu = () => {
    // menu dropdown hover (desktop only)
    const dropdowns = document.querySelectorAll('.dropdown');

    dropdowns.forEach(dropdown => {
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');

        dropdown.addEventListener('mouseover', () => {
            dropdownMenu.classList.add('show');
            dropdown.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'true');
        });

        dropdown.addEventListener('mouseout', (e) => {
            const related = e.relatedTarget;

            if (!dropdown.contains(related) && !dropdownMenu.contains(related)) {
                dropdownMenu.classList.remove('show');
                dropdown.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
            }
        });
    });

    // sidebar orçamento
    let etapa1 = document.querySelector('.etapa-1')
    let etapa2 = document.querySelector('.etapa-2')
    let etapa3 = document.querySelector('.etapa-3')

    let next1 = etapa1.querySelector('.btn-dark')
    let prev2 = etapa2.querySelector('.btn-stroke')
    let accept3 = etapa3.querySelector('.btn-dark')


    // etapa 1
    next1.onclick = () => { // toggle d-none on etapa1 & etapa2
        etapa1.classList.toggle('d-none')
        etapa1.setAttribute('tabindex', -1) // turn it focusable

        etapa2.classList.toggle('d-none')
        etapa2.setAttribute('tabindex', 1)
    }
    // etapa 2 -> prev
    prev2.onclick = () => {
        etapa1.classList.toggle('d-none')
        etapa1.setAttribute('tabindex', 1)

        etapa2.classList.toggle('d-none')
        etapa2.setAttribute('tabindex', -1)
    }
    // etapa 3
    accept3.onclick = () => {
        etapa1.setAttribute('tabindex', 1)
    }

    
    if ( screen.availWidth < 992 ) { // (mobile only)
        // remove link open dropdown toggle
        let togglers = document.querySelectorAll('.dropdown-toggle');

        togglers.forEach(toggler => {
            toggler.setAttribute('data-bs-toggle', 'dropdown')
        })


        // products submenu
        let dpdToggle = document.querySelector('#productsSubmenu .dropdown-toggle');
        let dpdMenu = document.querySelector('#productsSubmenu .dropdown-menu');

        dpdToggle.onclick = () => {
            dpdMenu.classList.toggle('show');
        }
    }
}